import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Stamp, StampProvider } from 'models';
import { Observable, map } from 'rxjs';
import { S9ApiStamp, createStampFromApi } from '../models';
import { Square9ApiConfig } from './square9-api-config.model';
import { SQUARE9_API_CONFIG } from './square9-api-config.token';

@Injectable({ providedIn: 'root' })
export class Square9ApiStampService implements StampProvider {
  private basePath: string;

  constructor(
    private http: HttpClient,
    @Inject(SQUARE9_API_CONFIG) private config: Square9ApiConfig
  ) {
    this.config.apiUrl$.subscribe(
      (apiUrl) => (this.basePath = `${apiUrl}/admin/stamps`)
    );
  }

  /** @inheritdoc */
  getStamps(): Observable<Stamp[]> {
    return this.http
      .get<S9ApiStamp[]>(this.basePath)
      .pipe(map((apiStamps) => apiStamps.map((s) => createStampFromApi(s))));
  }
}
